<template>
  <div
    class="w-full h-full"
    style="display: flex; align-items: center; justify-content: center;"
  >
    <v-progress-circular color="subtitlecolor" indeterminate />
  </div>
</template>

<script>
export default {
  name: 'WidgetLoading',
};
</script>
<style lang="scss" scoped>
.w-full {
  width: 100%;
}
.h-full {
  height: 100%;
}
</style>
